// Public-domain IANA zone.tab snapshot, 2026-10-17.
// This is a suggested country, not proof of residence or physical location.
import timezoneCountries from './timezoneCountries.json';

export function detectSignupCountry(timezone, languages = []) {
  const country = timezoneCountries[timezone];
  if (country) return country;
  for (const language of languages) {
    try {
      const region = new Intl.Locale(language).region;
      if (region && /^[A-Z]{2}$/.test(region)) return region;
    } catch { /* Try the next browser language. */ }
  }
  return '';
}
